import React, { useContext } from 'react';
import classNameBind from 'classnames/bind';

import styles from './Toast.module.css';
import Icon from '../Icon';
import Spinner from '../Spinner';
import Button from '../Button';
import { TranslationContext } from './TranslationContext';

const bindClasses = classNameBind.bind(styles);

const ToastContent = ({
  type,
  text,
  description,
  actions,
}) => {
  const t = useContext(TranslationContext);

  const icon = (() => {
    switch (type) {
      case 'error': return <Icon name="exclamation-mark-circle" color="white" />;
      case 'success': return <Icon name="checkmark-circle" color="white" />;
      case 'pending': return <Spinner inverseColor noMargin className="small" />;
      default: return null;
    }
  })();

  return (
    <div data-ppuc-id="NotificationService.notification">
      <div className={bindClasses('icon')}>
        {icon}
      </div>
      <div className={bindClasses('text')}>
        <div className={bindClasses('main-text')} data-ppuc-id="NotificationService.notification.message">
          {t(text)}
        </div>
        {description && (
          <div className={bindClasses('additional-text')} data-ppuc-id="NotificationService.notification.description">
            {t(description)}
          </div>
        )}
      </div>
      {(actions.length > 0) && (
        <div className={bindClasses('actions')}>
          {actions.map(action => (
            <Button
              key={action.id}
              appearance="subdued-inverse"
              text={t(action.text)}
              onClick={action.onClick}
              dataId="NotificationService.notification.action"
            />
          ))}
        </div>
      )}
    </div>
  );
};

export { ToastContent };
